<template>
  <div class="stepper">
    <div v-for="index in totalSteps" :key="index">
      <div
        :class="{ completed: stepNumber + 1 > index, remaining: stepNumber + 1 <= index }"
        class="step"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    stepNumber: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 32,
    },
  },
  methods: {
    setStep(index) {
      this.$emit('setStep', index);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '../styles/variables' as *;

.stepper {
  display: grid;
  grid-auto-flow: column;

  .current {
    background-color: $myTypeLightGray;
  }

  .step {
    min-height: 0.3em;
  }

  .step.completed {
    background-color: $myTypeRed;
  }

  .completed {
    background-color: $myTypeRed;
  }

  .remaining {
    background-color: $myTypeLightGray;
  }
}
</style>
